import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setDataAction } from '../../redux/Actions/SetDataAction'
import { CirclePlus, Trash2 } from 'lucide-react'
import AppButton from '../../components/AppButton/AppButton'
import PageHeader from '../../PageHeader/PageHeader'
import MyInput from '../../components/MyComponent/MyInput'
import { HitApi } from '../../Api/ApiHit'
import { addSurvey, searchSurvey, updateSurvey } from '../../constant/Constant'
import { useNavigate, useParams } from 'react-router-dom'
import toast from 'react-hot-toast'
import { SET_QUESTIONS_DATA } from '../../redux/ActionName/ActionName'

const AddSurvey = () => {
  const CreateSurvey = useSelector(state => state.CreateSurvey)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { id } = useParams()

  useEffect(() => {
    if (id)
      loadSurvey()
  }, [id])

  const loadSurvey = () => {
    const json = {
      page: 1, limit: 10, search: { _id: id }
    }
    HitApi(json, searchSurvey).then((res) => {
      if (res?.statusCode === 200) {
        dispatch(setDataAction(res?.data[0]?.questions, SET_QUESTIONS_DATA))
      }
    })
  }
  const AddQuestion = () => {
    const oldData = CreateSurvey?.questions || []
    const newData = [...oldData, { question: "" }]
    dispatch(setDataAction(newData, SET_QUESTIONS_DATA))
  }
  const handleDelete = (index) => {
    const oldData = [...CreateSurvey?.questions]
    oldData.splice(index, 1)
    dispatch(setDataAction(oldData, SET_QUESTIONS_DATA))
  }
  const handleChange = (value, index) => {
    const oldData = [...(CreateSurvey?.questions || [])]
    oldData[index] = { ...oldData[index], question: value }
    console.log({ oldData });
    dispatch(setDataAction(oldData, SET_QUESTIONS_DATA))
  }

  const AddForm = () => {
    const questions = CreateSurvey?.questions || []
    const hasEmpty = questions.some(q => !q.question?.trim())

    if (hasEmpty) {
      alert("Please fill all questions before submitting.")
      return
    }
    else {
      const json = {
        ...(id && { _id: id }),
        questions: questions,
        selected: false
      }

      HitApi(json, id ? updateSurvey : addSurvey).then((res) => {
        if (res.message === "Survey created successfully") {
          toast.success("Record Added Successfully")
        }
        if (res.message === "Survey updated successfully") {
          toast.success("Record Updated Successfully")
        }
      })
    }
    console.log("Final survey submitted:", questions)
    navigate("/survey")
  }
  console.log("CreateSurvey", CreateSurvey?.questions);

  return (
    <div>
      <PageHeader
        title={'Create Survey'}
        description={"Create and Edit Survey"}
      />
      {/* Add new question button */}
      <div className="my-3">
        <CirclePlus className="cursor-pointer" onClick={AddQuestion} />
      </div>
      {/* Questions list */}
      <div>
        {CreateSurvey?.questions?.map((e, index) => (
          <div className="flex gap-2" key={index}>
            <div className="w-full my-1">
              <MyInput
                title={`Question ${index + 1}`}
                onChange={(e) => handleChange(e.target.value, index)}
                value={CreateSurvey?.questions[index]?.question || ""}
              />
            </div>
            <div className="mt-8">
              <Trash2
                className="cursor-pointer text-red-500"
                onClick={() => handleDelete(index)}
              />
            </div>
          </div>
        ))}
      </div>

      {/* Submit button */}
      <div className='my-2'>
        <AppButton onClick={AddForm} buttontext={id ? "Update Survey" : "Add Survey"} />
      </div>
    </div>
  )
}

export default AddSurvey
